<template>
    <section
            class="main"
            style="position:relative; margin: 0 auto"
            :style="{'background-color': block.color,'padding-left':block.paddingLeft+'px','padding-right':block.paddingRight+'px', 'padding-top': block.paddingTop + 'px', 'padding-bottom': block.paddingBottom + 'px'}"
    >
        <div style="position: absolute; top: 16px; right: 16px;z-index: 2" class="hovered">
            <v-btn icon @click="$emit('move_row_up')">
                <v-icon>mdi-arrow-up</v-icon>
            </v-btn>
            <v-btn icon @click="$emit('move_row_down')">
                <v-icon>mdi-arrow-down</v-icon>
            </v-btn>
            <v-menu top left>
                <template v-slot:activator="{ on }">
                    <v-btn class="link-context-menu" v-on="on" icon  >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>

                </template>
                <v-list>

                    <v-list-item @click="$emit('copy_main_block')">
                        <v-list-item-title>Копировать</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="settings = true">
                        <v-list-item-title>Редактировать</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="$emit('block-delete')">
                        <v-list-item-title>Удалить</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>

        <v-dialog
                v-model="settings"
                max-width="600px"
                scrollable
        >
            <text-block-settings v-model="block" @close-settings="settings = false"></text-block-settings>

        </v-dialog>

        <v-container style="max-width: 1200px; margin: 0 auto">
            <v-row justify="center">
                <v-col class="text" :cols="12" :style="{'font-size': block.fontSize + 'px'}">
                    <html-editor v-model="block.content"></html-editor>
                </v-col>
            </v-row>
        </v-container>

    </section>
</template>

<script>
    import HtmlEditor from "./HtmlEditor";
    import TextBlockSettings from "./TextBlockSettings";
    export default {
        props:['block'],
        name: "TextBlock",
        components:{
            HtmlEditor,
            TextBlockSettings
        },
        data(){
            return {
                edit: false,
                fab: false,
                toggle_exclusive: 0,
                content: "",
                settings: false
            }
        },
        methods:{
            openPaddingControls(e){
                this.paddingControl.x = e.clientX;
                this.paddingControl.y = e.clientY;
                this.paddingControl.paddingContols = true;
            }
        },
        watch:{
            content: function (val) {
                if(val == ""){
                    this.$emit("block-delete")
                }
                this.block.content = val
            },
            toggle_exclusive(val){
                switch(val){
                    case 0:
                        this.block.align = 'left'
                        break
                    case 1:
                        this.block.align = 'center'
                        break
                    case 2:
                        this.block.align = 'right'
                        break
                    case 3:
                        this.block.align = 'justify'
                        break
                }
            }
        },
        mounted(){
           // this.$refs.ce.innerHTML = this.block.content;
        }

    }
</script>

<style scoped>

    .text{
        color: #000000;
        /*font-size: 3px;*/
        /*line-height: 1.35;*/
        font-family: 'PT Sans',Arial,sans-serif;
        /*font-weight: 400;*/
    }

    .text textarea{
        width: 100%;
        position: relative;
        overflow: auto;
        z-index: 100;
        height:350px
    }

    .text-align-justify{
        text-align: justify;
    }

    .text-align-left{
        text-align: left;
    }

    .text-align-right{
        text-align: right;
    }

    .text-align-center{
        text-align: center;
    }

    .main{

    }

    .hovered{
        opacity: 0;
        transition: 0.3s;
    }

    .main:hover .hovered{
        opacity: 1;
    }

</style>
